import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-cancel-x',
    templateUrl: './icon-cancel-x.component.html'
})
export class IconCancelXComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit(): void {
    }

}
